export const CHOOSE_CHILD = 'wybieram-podopiecznego';
export const CHANGE_CHILD = 'zmieniam-podopiecznego';

export const YOUTUBE_PAGE_URL = 'https://www.youtube.com/@KupujiPomagaj';
export const FACEBOOK_PAGE_URL = 'https://www.facebook.com/kupujipomagaj';
export const LINKEDIN_PAGE_URL = 'https://www.linkedin.com/company/kupujipomagaj/';

export const PODOPIECZNI_WYBIERZ_PODOPIECZNEGO_SUBTITLE = 'Wybierz osobę, która będzie otrzymywać środki, za każdym razem, gdy zrobisz zakupy w sklepie partnerskim.';
export const PODOPIECZNI_ZMIEN_PODOPIECZNEGO_SUBTITLE = 'Wybierz nowego podopiecznego, którego chcesz wspierać.';
export const PODOPIECZNI_WYBIERZ_PODOPIECZNEGO_I_ROB_ZAKUPY_SUBTITLE = 'Zanim przejdziesz do sklepu, wybierz osobę, która otrzyma wsparcie, kiedy zrobisz zakupy.';
